import React, { Component } from 'react';
import { $tv } from 'react-tv-focusable';
// import { getCookie } from '../../util/cookie';
import './parentGuidelines.scss';
import { keycodeHandle, isAstro } from '../../util/util';
import { withCustomTranslation, getTvdSegment, WETV_TEXT_CONTENT } from '@/hooks/useCustomTranslation';
import { astroQuitApplication } from '../../request/http';
export default withCustomTranslation(class NewSboutUs extends Component {
  constructor(props) {
    super(props);
    this.jumpTimer = null;
    this.state = {
      parent: [
        {
          title: 'Privacy Policy',
          isFocus: false,
        },
        {
          title: 'Do Not Agree and Exit',
          isFocus: false,
        },
        {
          title: 'Accept and Continue',
          isFocus: false,
        },
      ],
    };
  }
  componentDidMount() {
    keycodeHandle({ exit: this.aboutUsKeyDown, quit: this.aboutUsKeyDown });
    // 选中方式
    const parentEls = document.querySelectorAll('.parent_Options_s');
    parentEls.forEach((el) => {
      el.addEventListener('onFocus', this.parentFocus.bind(this));
      el.addEventListener('onBlur', this.parentBlur.bind(this));
      // el.addEventListener("down", this.parentDown.bind(this));
      el.addEventListener('click', this.parentClick.bind(this));
      el.addEventListener('mouseenter', this.parentMouseenter.bind(this));
    });
    $tv.requestFocus(this.refs.parentMark1);
  }
  componentWillUnmount() {
    if (this.jumpTimer) {
      clearTimeout(this.jumpTimer);
      this.jumpTimer = null;
    }
    this.setState = () => false;
    keycodeHandle({});
  }
  // 监听esc和Backspace事件
  aboutUsKeyDown = (e) => {
    e && e.preventDefault && e.preventDefault();
    this.closeWebPage();
  };
  // 选中方式点击
  parentClick(event) {
    const index = Number(event.target.getAttribute('index'));
    if (index === 0) {
      this.props.history.push('/termsPolicy/');
    }
    if (index === 1) {
      this.closeWebPage();
    }
    if (index === 2) {
      localStorage.setItem('parentGuidelines', true);
      const acceptPrivacyOriginPage = sessionStorage.getItem('acceptPrivacyOriginPage')?.replace('#', '') || '/';
      this.props.history.replace(acceptPrivacyOriginPage);
    }
  }
  // 选中方式鼠标获焦
  parentMouseenter(event) {
    const index = Number(event.target.getAttribute('index'));
    $tv.requestFocus(this.refs[`parentMark${index + 1}`]);
  }
  // 选中方式获焦
  parentFocus(event) {
    const index = Number(event.target.getAttribute('index'));
    const currentParent = this.state.parent;
    currentParent[index].isFocus = true;
    this.setState({
      parent: currentParent,
    });
  }
  // 选中方式失焦
  parentBlur(event) {
    clearTimeout(this.timeout);
    const index = Number(event.target.getAttribute('index'));
    const currentParent = this.state.parent;
    currentParent[index].isFocus = false;
    this.setState({
      parent: currentParent,
    });
  }
  // 关闭浏览器
  closeWebPage() {
    if (isAstro()) {
      astroQuitApplication();
      return;
    }
    if (navigator.userAgent.indexOf('MSIE') > 0) {
      // IE
      if (navigator.userAgent.indexOf('MSIE 6.0') > 0) {
        // IE6
        window.opener = null;
        window.close();
      } else {
        // IE6+
        window.open('', '_top');
        try {
          window.top.close();
        } catch (e) {
          console.log('closeWebPage error', e);
        }
      }
    } else {
      window.location.href = 'about:blank';
      window.opener = null;
      window.open('', '_self', '');
      window.close();
    }
  }
  render() {
    return (
      <div className="parentWrapper">
        <div className="parentContainer">
          <div className="parentLeft">
            <div className="parentLeft_header">
              <div
                className={`parentLogo ${this.state.isIflix ? 'parentLogo_iflix' : ''} ${getTvdSegment() === 'tvdtv' ? 'parentLogo_tvdtv' : ''}`}
              ></div>
                <div className="parentTitle">welcome to {WETV_TEXT_CONTENT}</div>
            </div>
            <div className="parentLeft_Container">
              {`Welcome to ${WETV_TEXT_CONTENT}. Before entering ${WETV_TEXT_CONTENT},
              you need to confirm that you are 16 years old or above,
              and click to read the "Privacy Policy",
              and then click the "Accept and Enter" button.`}
            </div>
          </div>
          <div className="parentRight">
            <div className="parent_Way">
              {this.state.parent.map((item, index) => (
                <span
                  focusable
                  ref={`parentMark${index + 1}`}
                  key={index}
                  className={[item.isFocus ? 'parent_Options_h' : 'parent_Options_s'].join(' ')}
                  index={index}
                >
                  {this.props.t(item.title)}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
});
